"use strict";
exports.__esModule = true;
exports.reflect = void 0;
var reflect = function (declare) {
    declare("RippleLikeAddress", {
        methods: {
            toBase58: {}
        }
    });
    declare("RippleLikeOperation", {
        methods: {
            getTransaction: {
                returns: "RippleLikeTransaction"
            }
        }
    });
    declare("RippleLikeTransaction", {
        methods: {
            getHash: {},
            getDestinationTag: {},
            getSequence: {
                returns: "BigInt"
            },
            getFees: {
                returns: "Amount"
            },
            getReceiver: {
                returns: "RippleLikeAddress"
            },
            getSender: {
                returns: "RippleLikeAddress"
            },
            serialize: {
                returns: "hex"
            },
            setSignature: {
                params: ["hex", "hex"]
            },
            setDERSignature: {
                params: ["hex"]
            }
        }
    });
    declare("RippleLikeTransactionBuilder", {
        methods: {
            wipeToAddress: {},
            sendToAddress: {
                params: ["Amount"]
            },
            setFees: {
                params: ["Amount"]
            },
            setDestinationTag: {},
            build: {
                returns: "RippleLikeTransaction"
            }
        }
    });
    declare("RippleLikeAccount", {
        methods: {
            buildTransaction: {
                returns: "RippleLikeTransactionBuilder"
            },
            broadcastRawTransaction: {
                params: ["hex"]
            },
            getFees: {
                returns: "Amount"
            },
            getBaseReserve: {
                returns: "Amount"
            },
            isAddressActivated: {}
        }
    });
    return {
        OperationMethods: {
            asRippleLikeOperation: {
                returns: "RippleLikeOperation"
            }
        },
        AccountMethods: {
            asRippleLikeAccount: {
                returns: "RippleLikeAccount"
            }
        }
    };
};
exports.reflect = reflect;
//# sourceMappingURL=types.js.map